import { InjectedIntlProps, injectIntl } from 'react-intl';
import { compose } from 'recompose';
import { ITournamentAward } from '../typings';

interface IOwnProps {
  award: ITournamentAward;
}

export type IComponentProps = IOwnProps & InjectedIntlProps;

export const connector = compose<IComponentProps, IOwnProps>(
  injectIntl
);
